export default {
	title: '设备类型列表',
	actions: {
		add: '新增',
		edit: '修改',
		delete: '删除',
		batchDelete: '批量删除',
		save: '保存',
		cancel: '取消',
		confirm: '确定'
	},
	messages: {
		deleteSuccess: '删除成功',
		actionSuccess: '操作成功'
	},
	labels: {
		deviceTypeList: '设备类型列表'
	},
	buttons: {
		add: '新增',
		batchDelete: '批量删除',
		edit: '修改',
		delete: '删除'
	},
	table: {
		id: 'id',
		deviceTypeName: '设备类型名称',
		icon: '图标',
		accThreshold: '加速度门限阈值',
		speedThreshold: '速度门限阈值',
		tempThreshold: '温度门限阈值',
		action: '操作'
	},
	form: {
		placeholder: {
			name: '名称'
		}
	},
	config: {
		gridLayout: '格栅布局',
		name: '名称',
		icon: '图标',
		accThreshold: '加速度门限阈值',
		speedThreshold: '速度门限阈值',
		tempThreshold: '温度门限阈值',
		remark: '备注',
		nameRequired: '必填项不能为空'
	},
	dialog: {
		add: '新增',
		update: '修改'
	}
}
